import { render, staticRenderFns } from "./fvc-bearbeitung.vue?vue&type=template&id=6c481266&scoped=true"
import script from "./fvc-bearbeitung.vue?vue&type=script&lang=js"
export * from "./fvc-bearbeitung.vue?vue&type=script&lang=js"
import style0 from "./fvc-bearbeitung.vue?vue&type=style&index=0&id=6c481266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c481266",
  null
  
)

export default component.exports